'use es6';

import { formatCurrencyName } from '../internal/utils/CurrencyLabelFormatters';
export default formatCurrencyName;